/**
 * HeaderSlot — ช่องในแถบหัวเว็บ (ข้างตะกร้า/กระดิ่ง) ให้ปุ่มของหน้าต่างลอย (งานผลิต · งาน · แชต) มาวาง (20 ต.ค. 2569)
 *
 * ผู้ใช้ (iPad): "ย้ายป๊อปอัปพวกนั้นไปไว้ด้านบน รวมกับตะกร้า กระดิ่ง" — ปุ่มกลมมุมขวาล่างทับปุ่ม ถัดไป/บันทึก ของฟอร์ม
 *   Header วาง <div id="header-dock-slot"> · แต่ละ Dock ใช้ <HeaderSlotPortal> ส่งปุ่มของตัวเองเข้าไป (createPortal)
 *   ตัวนับ/สถานะของแต่ละปุ่มยังอยู่ในไฟล์ Dock เดิม ไม่ต้องย้าย state
 */
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const HEADER_SLOT_ID = "header-dock-slot";

// หน้าต่างที่เปิดจากปุ่มบนหัวเว็บ — ลงมาใต้แถบหัว ชิดขวา (คลาสเต็ม ให้ Tailwind เห็น)
export const HEADER_PANEL_POS = "fixed top-[4.25rem] right-3 z-[1000]";

export function HeaderSlotPortal({ children }) {
  const [el, setEl] = useState(() => document.getElementById(HEADER_SLOT_ID));
  useEffect(() => {
    if (el && document.body.contains(el)) return undefined;
    const find = () => {
      const x = document.getElementById(HEADER_SLOT_ID);
      if (x) setEl(x);
      return x;
    };
    if (find()) return undefined;
    // หัวเว็บอาจวาดทีหลัง (เพิ่งล็อกอิน) — คอยจนช่องโผล่
    const mo = new MutationObserver(() => { if (find()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, [el]);
  return el ? createPortal(children, el) : null;
}

// หน้าตาปุ่มบนหัวเว็บ — ขนาดเดียวกับปุ่มตะกร้า
export const headerIconBtn = "relative flex items-center justify-center w-8 h-8 rounded-full border transition-colors";
